import { axiosInstance } from './JsdhNotifikaceService';
import { handleRequest } from '../../axios';
import {
    ZASAH_OSA_URL,
    ZASAH_DO_ZPRAVY_URL,
    ZASAH_ZAMKNOUT_URL,
    ZASAH_ODEMKNOUT_URL,
    ZASAH_PODKLAD_URL,
    ZASAH_PODKLAD_PDF_URL,
} from '../url';
import { OsaResponse } from '../generated/models/OsaResponse';
import { PodkladResponse } from '../generated/models/PodkladResponse';

/** HO-148 Task 6: telo `PUT /api/poplach/{id}/do-zpravy/{typ}/{eid}` (mirror BE `OznacDoZpravyRequest`). */
export interface OznacDoZpravyData {
    doZpravy: boolean;
    /** Volitelna - vyplnena jen kdyz `doZpravy === true` (BE normalizuje jinak na `null`). */
    kategorie: string | null;
}

export const getOsa = (poplachId: number) =>
    handleRequest<OsaResponse>(() =>
        axiosInstance.get(ZASAH_OSA_URL(poplachId))
    );

export const getPodklad = (poplachId: number) =>
    handleRequest<PodkladResponse>(() =>
        axiosInstance.get(ZASAH_PODKLAD_URL(poplachId))
    );

/** `typ`: `'zprava' | 'priloha'` - shoduje se s BE `ZasahController#oznacDoZpravy`. */
export const oznacDoZpravy = (poplachId: number, typ: 'zprava' | 'priloha', entitaId: number, data: OznacDoZpravyData) =>
    handleRequest<void>(() =>
        axiosInstance.put(ZASAH_DO_ZPRAVY_URL(poplachId, typ, entitaId), data)
    );

/** Rucni uzamceni vlakna po zdokumentovani zasahu - jen ADMIN (BE `ZasahController#uzamkniVlakno`). */
export const zamknoutVlakno = (poplachId: number) =>
    handleRequest<void>(() =>
        axiosInstance.post(ZASAH_ZAMKNOUT_URL(poplachId))
    );

/** Trvale odemkne automaticky/rucne uzamcene vlakno - jen ADMIN (BE `ZasahController#odemkniVlakno`). */
export const odemknoutVlakno = (poplachId: number) =>
    handleRequest<void>(() =>
        axiosInstance.post(ZASAH_ODEMKNOUT_URL(poplachId))
    );

/**
 * Stahne PDF verzi podkladu a rovnou spusti ulozeni v prohlizeci (mirror
 * `JsdhNotifikaceService.downloadPdf`). Endpoint je ADMIN only a funguje bez
 * hlavicky `Accept` (BE oprava commit 15685f3) - `axiosInstance` ji neposila.
 */
export const downloadPodkladPdf = async (poplachId: number): Promise<void> => {
    const response = await axiosInstance.get(ZASAH_PODKLAD_PDF_URL(poplachId), {
        responseType: 'blob',
    });
    const blob = new Blob([response.data], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `podklad_zasahu_${poplachId}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
};
